<p-card>
    <div class="text-center">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="mb-4">
            <p-progressSpinner></p-progressSpinner>
            <p class="mt-3 text-600">Traitement du retour en cours...</p>
        </div>

        <!-- Success State -->
        <div *ngIf="!isLoading && isSuccess">
            <div class="mb-4">
                <i class="pi pi-check-circle text-green-500" style="font-size: 4rem;"></i>
            </div>
            <h2 class="text-green-600 mb-3">Retour confirmé avec succès!</h2>
            <p class="text-600 mb-4">L'emprunt a été retourné manuellement avec succès.</p>
            
            <div *ngIf="empruntId" class="mb-4">
                <p class="text-sm text-500">Numéro d'emprunt: <strong>{{empruntId}}</strong></p>
            </div>
            
            <div class="flex justify-content-center gap-2">
                <p-button 
                    label="Voir les détails de l'emprunt" 
                    icon="pi pi-eye"
                    styleClass="p-button-outlined"
                    *ngIf="empruntId"
                    [routerLink]="['/emprunt', empruntId]">
                </p-button>
                <p-button 
                    label="Retour à la liste des emprunts" 
                    icon="pi pi-list"
                    [routerLink]="['/emprunt']">
                </p-button>
            </div>
        </div>

        <!-- Error State -->
        <div *ngIf="!isLoading && !isSuccess">
            <div class="mb-4">
                <i class="pi pi-times-circle text-red-500" style="font-size: 4rem;"></i>
            </div>
            <h2 class="text-red-600 mb-3">Erreur lors du retour</h2>
            <p class="text-600 mb-4" style="white-space: pre-wrap;">{{errorMessage}}</p>
            
            <div *ngIf="empruntId" class="mb-4">
                <p class="text-sm text-500">Numéro d'emprunt: <strong>{{empruntId}}</strong></p>
            </div>
            
            <div class="flex justify-content-center gap-2">
                <p-button 
                    label="Voir les détails de l'emprunt" 
                    icon="pi pi-eye"
                    styleClass="p-button-outlined"
                    *ngIf="empruntId"
                    [routerLink]="['/emprunt', empruntId]">
                </p-button>
                <p-button 
                    label="Retour à la liste des emprunts" 
                    icon="pi pi-list"
                    [routerLink]="['/emprunt']">
                </p-button>
            </div>
        </div>
    </div>
</p-card> 